import getParentNode from "./getParentNode.es.js";
import isScrollParent from "./isScrollParent.es.js";
import getNodeName from "./getNodeName.es.js";
import { isHTMLElement } from "./instanceOf.es.js";
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
export {
  getScrollParent as default
};
//# sourceMappingURL=getScrollParent.es.js.map
